import React, { useLayoutEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { logout } from 'app/shared/reducers/authentication';

export const Logout = (props: RouteComponentProps<any>) => {
  const logoutUrl = useAppSelector(state => state.authentication.logoutUrl);
  const idToken = useAppSelector(state => state.authentication.idToken);
  const dispatch = useAppDispatch();
  const { location } = props;
  const { from } = (location.state as any) || { from: { pathname: '/', search: location.search } };

  useLayoutEffect(() => {
    dispatch(logout());
    if (logoutUrl) {
      // if Keycloak, logoutUrl has protocol/openid-connect in it
      window.location.href = logoutUrl.includes('/protocol')
        ? logoutUrl + '?redirect_uri=' + window.location.origin
        : logoutUrl + '?id_token_hint=' + idToken + '&post_logout_redirect_uri=' + window.location.origin;
    }
  });

  return <Redirect to={from} />;
};

export default Logout;
